const folders = {
  folders: "תיקיות",
  createFolder: "צור תיקייה",
  folderName: "שם תיקייה",
  folderIcon: "אייקון",
  gridSize: "גודל רשת",
  columns: "עמודות",
  rows: "שורות",
  items: "פריטים",
  pin: "הצמד פתוח",
  unpin: "בטל הצמדה",
  addWidget: "הוסף ווידג׳ט",
  addShortcut: "הוסף קיצור",
  addAction: "הוסף פעולה",
  widgetsTab: "ווידג׳טים",
  actionsTab: "פעולות",
  noItems: "התיקייה ריקה",
  editFolder: "ערוך תיקייה",
  deleteFolder: "מחק תיקייה",
  bookmarksTab: "סימניות",
  addBookmark: "הוסף",
  bookmarkName: "שם סימנייה",
  bookmarkUrl: "כתובת URL או /dashboard/...",
  bookmarkIcon: "אייקון",
  addCurrentPage: "דף נוכחי",
} as const;
export default folders;
